import { Button } from '@kanda-libs/ks-design-library';
import useBackStepButton from './useBackStepButton';

const BackStepButton: React.FunctionComponent = function () {
  const { show, onClick } = useBackStepButton();
  if (!show) return undefined;
  return (
    <Button.Icon
      id="enquiry-apply-back-step"
      icon="arrow-left"
      className="-ml-3"
      onClick={onClick}
    />
  );
};

export default BackStepButton;
